// @flow

export const typeToLabel = (type: string): string => {
    const typeLabels = {
        LOAD_IN: "Load In",
        LOAD_OUT: "Load Out",
        REHEARSAL: "Rehearsal",
        CONSTRUCTION: "Construction",
    };
    return type && typeLabels[type] ? typeLabels[type] : "";
};
